import { Target } from 'models/Target/Target.model';
import { SbtiTarget } from 'models/Sbti/sbti.model';
import { TargetTexts } from '../constants';

interface HandleSubmitParams {
    values: Target;
    isEdit: boolean | undefined;
    initialFilteredValues: Target;
    updateTarget: (id: number, data: Partial<Target>) => Promise<boolean>;
    createTarget: (data: Target) => Promise<boolean>;
    closeHandler: () => void;
    setSelectedTarget?: React.Dispatch<React.SetStateAction<string>>;
    setSelectedTargetId?: React.Dispatch<React.SetStateAction<number | undefined>>;
    setSelectedIndex?: React.Dispatch<React.SetStateAction<number>>;
    sbtiTargets?: SbtiTarget[];
    fetchSbtiTargets?: () => Promise<void>;
}

export const handleSubmitUtil = async ({
    values,
    isEdit,
    initialFilteredValues,
    updateTarget,
    createTarget,
    closeHandler,
    setSelectedTarget,
    setSelectedTargetId,
    setSelectedIndex,
    sbtiTargets,
    fetchSbtiTargets,
}: HandleSubmitParams) => {
    if (isEdit && initialFilteredValues?.id) {
        const { id, organizationName, ...restWithoutId } = values;
        const isScience = values?.targetCategory === TargetTexts.SCIENCE_BASED;

        if (isScience) {
            const { totalReduction, ...restItems } = restWithoutId;
            const res = await updateTarget(initialFilteredValues?.id, restItems);
            if (res) {
                closeHandler();
                setSelectedTarget?.(values.targetName || '');
                setSelectedTargetId?.(values?.id);
            }
        } else {
            const res = await updateTarget(initialFilteredValues?.id, restWithoutId);
            if (res) {
                closeHandler();
                setSelectedTarget?.(values.targetName || '');
                setSelectedTargetId?.(values?.id);
            }
        }

        const index = sbtiTargets?.findIndex(
            (target: SbtiTarget) => target.id === Number(initialFilteredValues?.id)
        );
        index && setSelectedIndex?.(index);
        await fetchSbtiTargets?.();
    } else {
        const res = await createTarget(values);
        if (res) {
            await fetchSbtiTargets?.();
            closeHandler();
        }
    }
};